// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-product-record',
    // #endregion
    // #region Properties
    props: {
        product: {
            type: Object,
            required: false,
            default: {}
        },
    },
    // #endregion
    // #region Core
    methods: {
        getImageUrl(product) {
            if (utils.isNull(product.images)) {
                return '';
            }
            return product.images[0].url;
        },
    }
    // #endregion
});
// #endregion
